import { render } from "./TabsPage.vue?vue&type=template&id=0622e4c2&ts=true"
import script from "./TabsPage.vue?vue&type=script&lang=ts"
export * from "./TabsPage.vue?vue&type=script&lang=ts"

import "./TabsPage.vue?vue&type=style&index=0&id=0622e4c2&lang=scss"

import exportComponent from "/home/runner/work/e-wallet-fe/e-wallet-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__